// Vendors
import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom'; // Router functions

// Components
import ProtectedRoute from '@/components/providers/ProtectedRoute/ProtectedRoute'; // Uncomment if needed
import ErrorBoundary from '@/components/atoms/ErrorBoundary/ErrorBoundary';
import MainLayout from '@/components/templates/MainLayout';
import ContractDetailPage from '@/components/pages/ContractDetailsPage';
import AttachmentViewer from '@/components/pages/AttachmentViewer/AttachmentViewer';

// Assets
import '@/assets/styles/main.scss';

// Lazy Loaded Pages
const LoginPage = lazy(() => import('@/components/pages/LoginPage'));
const ContractSearchPage = lazy(() => import('@/components/pages/SearchPage'));

import { Navigate } from 'react-router-dom';


export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
    errorElement: <ErrorBoundary />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <MainLayout />,
        errorElement: <ErrorBoundary />,
        children: [
          {
            path: '/search',
            element: <ContractSearchPage />,
          },
          {
            path: '/contracts/:contractId/client/:clientId',
            element: <ContractDetailPage />,
          },
        ],
      },
      {
        path: '/attachments/*',
        element: <AttachmentViewer />,
      },
      {
        path: '*',
        element: <Navigate to="/login" replace />,
      },
    ],
  },
]);
